module.exports = __webpack_public_path__ + "img/国家荔枝种质资源圃1.b1fdbb9d.png";